export default __webpack_public_path__ + "static/media/landscape1-MASK-wood.2dd98bb4.png";